
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    save_ins: [
        {num: 1, txt: "Savings 1", amt:550.00},
        {num: 2, txt: "Savings 2", amt: 100.00,},
        {num: 3, txt: "Savings 3", amt: 300.00},
    ]
};

export const savingsSlice = createSlice({
    name: 'savings_slice',
    initialState
});



export default savingsSlice.reducer;